import { useState } from "react";
import { CameraView, hasCamera } from "./CameraView.js";
import { Dialog } from "./Dialog.js";
import { Notice } from "./Notice.js";

/**
 * The search box's camera: read one code and hand it back to be searched for.
 *
 * Unlike `ScanSerialDialog` there is nothing to check first -- a wrong read is
 * a search with no results, put right by scanning again -- so the first code
 * read closes it. The Items screen opens one of our own labels as the thing
 * it labels and searches for anything else, which is how a serial off a box
 * finds the item it belongs to.
 */
export function ScanSearchDialog({
  onRead,
  onClose,
}: {
  onRead: (text: string) => void;
  onClose: () => void;
}) {
  const [camera, setCamera] = useState<"on" | "denied" | "unsupported">(hasCamera() ? "on" : "unsupported");

  return (
    <Dialog title="Scan to search" onClose={onClose}>
      <div className="stack">
        {camera === "unsupported" ? (
          <Notice tone="warn">
            This browser cannot use the camera here. Type in the search box instead.
          </Notice>
        ) : camera === "denied" ? (
          <Notice tone="error">The camera could not start. Check that this site may use it.</Notice>
        ) : (
          <>
            <CameraView
              onRead={(text) => {
                onRead(text.trim());
                onClose();
              }}
              onFail={() => setCamera("denied")}
            />
            <p className="muted small">
              A serial number, a product barcode, or one of our labels. A label opens what it is on.
            </p>
          </>
        )}
      </div>
    </Dialog>
  );
}
